<template>
  <div>
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">Tarifario</th>
          <th scope="col">Nivel</th>
          <th scope="col">Código</th>
          <th scope="col">Descripción</th>
          <th scope="col">Uvr</th>
          <th scope="col">Fc</th>
          <th scope="col">Valor</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="tarifa in datosPaginados" :key="tarifa.idTarifa">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(tarifa.idTarifa)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(tarifa.idTarifa)" title="Editar">edit_square</i></td>
          <td>{{tarifa.tarifarioDescripcion}}</td>
          <td>{{tarifa.nivel}}</td>
          <td>{{tarifa.elementoCodigo}}</td>
          <td>{{tarifa.elementoNombre}}</td>
          <td>{{tarifa.uvr}}</td>
          <td>{{tarifa.fc}}</td>
          <td>{{tarifa.valor}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTarifa(tarifa.idTarifa)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idTarifa" class="form-label">IdTarifa</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTarifa" name="idTarifa" v-model="datoTarifa.idTarifa" disabled>
                </div>
              </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemento" class="form-label"> Elemento</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idElemento" name="idElemento" v-model="datoTarifa.idElemento">
                      <option v-for="elemento in elementos" :value="elemento.idElemento" :key="elemento.idElemento">
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Elemento -->
<!-- Botón Lista de Valores  Tarifario -->
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idTarifario" class="form-label"> Tarifario</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idTarifario" name="idTarifario" v-model="datoTarifa.idTarifario">
                      <option v-for="tarifario in tarifarios" :value="tarifario.idTarifario" :key="tarifario.idTarifario">
                        {{ tarifario.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
            </div>
<!-- Botón Lista de Valores  Tarifario -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nivel" class="form-label">Nivel</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nivel" name="nivel" v-model="datoTarifa.nivel" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="uvr" class="form-label">Uvr</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="uvr" name="uvr" v-model="datoTarifa.uvr" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fc" class="form-label">Fc</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="fc" name="fc" v-model="datoTarifa.fc" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="valor" class="form-label">Valor</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="valor" name="valor" v-model="datoTarifa.valor" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarTarifa" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTarifa" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
  </div>
</template>
<script>
import { validarForm } from '../../modules/validacionesForms.js'
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
  },
  data () {
    return {
      tarifas : [],
      datoTarifa : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      elementos: [],
      tarifarios: [],
    }
  },
  mounted () {
    this.getDataPaginaTodos(this.paginaActual)
    this.fetchElementos()
    this.fetchTarifarios()
  },
  methods : {
    totalPaginas(){
      return Math.ceil(this.tarifas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwtarifas/nombre/'+this.nombreBusqueda).then(response=>{ 
          this.tarifas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.tarifas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwtarifas').then(response=>{ 
      this.tarifas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.tarifas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarForm(){
      const requiredFields = [
        'idElemento'
        ,'idTarifario'
        ,'nivel'
        ,'uvr'
        ,'fc'
        ,'valor'
      ];
      const requiredFieldsText = [
        'idElemento'
        ,'idTarifario'
        ,'nivel'
        ,'uvr'
        ,'fc'
        ,'valor'
      ];
      return validarForm(this.datoTarifa, requiredFields, requiredFieldsText);
    },
    async guardarTarifa(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifas', this.datoTarifa)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Tarifa creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTarifa(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tarifas', this.datoTarifa)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Tarifa creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoTarifa={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirModalEditar(idTarifa){
      this.modalWindow = true
      if(idTarifa != null){    
           api.get('/vwtarifas/'+idTarifa).then(resp=>{
          this.datoTarifa = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    abrirEditar(idTarifa){
      if(idTarifa != null){
        this.$router.push('/tarifamd/'+idTarifa)
      }
    },
    async deleteTarifa (idTarifa) {
      try{
        await api.delete('/tarifas/'+idTarifa)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
async fetchElementos() {
  try {
    const response = await api.get("/vwelementos");
    this.elementos = response.data;
  } catch (error) {
    console.error("Error al obtener los elementos:", error);
  }
},

async fetchTarifarios() {
  try {
    const response = await api.get("/vwtarifarios");
    this.tarifarios = response.data;
  } catch (error) {
    console.error("Error al obtener los tarifarios:", error);
  }
},
  },
}
</script>
